import React, { Fragment, useState } from "react";
import TalkToUsPopup from "./talk-to-us-popup";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { collection, addDoc } from "firebase/firestore/lite";
import { utils } from "@core/helper";
import Loading from "./loading";
import talk_to_us from "../../images/talk_to_us.png";
import { Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import { collectionKeys } from "@core/helper/utils";

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const validationSchema = Yup.object().shape({
  name: Yup.string().label("Name").required(),
  email: Yup.string()
    .matches(emailRegex, "Invalid email address")
    .label("Email")
    .required(),
  mobile: Yup.string().label("Contact").required(),
  country: Yup.string().label("Country").optional(),
  content: Yup.string().label("Content").required(),
  service: Yup.string().label("Service").required(),
});

const TalkToUsNew = (props) => {
  // console.log("props", props)
  const { db, label = "TALK TO US", isFor, customClass } = props;
  const [loading, setLoading] = useState(false);
  const [talkToUsShow, setTalkToUsShow] = useState(false);
  const [number, setNumber] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleToggleTalkToUs = () => {
    setTalkToUsShow(!talkToUsShow);
    reset();
  };

  const handleOnChange = (value, country) => {
    setValue("country", country.countryCode, { shouldValidate: true });
    setValue("mobile", value, { shouldValidate: true });
    setNumber(value);
  };

  const handleOnSubmit = async (values) => {
    const { name, email, country, content, mobile, service } = values;
    const payload = {
      name,
      email,
      country,
      content,
      mobile,
      service,
      date: new Date(),
      status: true,
    };

    setLoading(true);
    try {
      const clients = collection(db, collectionKeys.CLIENTS);
      await addDoc(clients, payload);
      handleToggleTalkToUs();
      reset();
      setNumber("");
      setLoading(false);
      setTimeout(() => {
        utils.showSuccssMsg("We will contact/talk to you soon");
      }, 500);
    } catch (e) {
      utils.showErrMsg("Error adding document");
      setLoading(false);
    }
  };

  const getButtonFor = (isFor) => {
    // If customClass is provided, use it for the button style
    if (customClass) {
      return (
        <span
          role="button"
          tabIndex="0"
          className={customClass}
          onKeyDown={(e) => { }}
          onClick={handleToggleTalkToUs}>
          <span>{label}</span>
        </span>
      );
    }
    switch (isFor) {
      case "banner":
        return (
          <span
            role="button"
            tabIndex="0"
            className="primary_btn"
            onKeyDown={(e) => { }}
            onClick={handleToggleTalkToUs}>
            {label}
          </span>
        );
      case "about":
        return (
          <span
            role="button"
            tabIndex="0"
            className="about_rhs_btn"
            onKeyDown={(e) => { }}
            onClick={handleToggleTalkToUs} >
            {label}
          </span>
        );
      case "cta":
        return (
          <span
            role="button"
            tabIndex="0"
            className="cta_btn_div"
            onKeyDown={(e) => { }}
            onClick={handleToggleTalkToUs}>
            {label}
          </span>
        );
      default:
        return (
          <span
            role="button"
            tabIndex="0"
            className="primary_btn"
            onKeyDown={(e) => { }}
            onClick={handleToggleTalkToUs}>
            {label}
          </span>
        );
    }
  };

  return (
    <Fragment>
      {getButtonFor(isFor)}
      <TalkToUsPopup
        show={talkToUsShow}
        onHide={() => handleToggleTalkToUs()}
        closeButton={true}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <div className="talk_us_wrapper">
          <Row className="flex-column-reverse flex-md-row">
            <Col >
              <div className="talk_us_left">
                <form
                  className="form_field"
                  onSubmit={handleSubmit(handleOnSubmit)}
                >
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Your Name"
                      className="talk_input"
                      {...register("name")}
                    />
                    <p className="text-danger mb-0">{errors.name?.message}</p>
                  </div>
                  <div>
                    <input
                      type="mail"
                      placeholder="Enter Your Email"
                      className="talk_input"
                      {...register("email")}
                    />
                    <p className="text-danger mb-0">{errors.email?.message}</p>
                  </div>
                  <div>
                    <PhoneInput
                      className="talk_phone_input"
                      country={"us"}
                      value={number}
                      enableSearch
                      searchPlaceholder=""
                      {...register("mobile")}
                      onChange={handleOnChange}
                    />
                    <p className="text-danger mb-0">{errors.mobile?.message}</p>
                  </div>

                  <div className="login__field">
                    <select
                      className="talk_input round"
                      {...register("service")}
                    >
                      <option value="">Select your services</option>
                      <option value="crypto exchange development">
                        Crypto Exchange Development
                      </option>
                      <option value="nft marketplace development">
                        NFT Marketplace Development
                      </option>
                      <option value="defi development">DeFi Development</option>
                      <option value="metaverse development">
                        Metaverse Development
                      </option>
                      <option value="blockchain solutions">
                        Blockchain Solutions
                      </option>
                      <option value="web 3.0 development">
                        Web 3.0 Development
                      </option>
                      <option value="crypto wallet development">
                        Crypto Wallet Development
                      </option>
                      <option value="custom software development">
                        Custom Software Development
                      </option>
                      <option value="mobile app development services">
                        Mobile App Development Services
                      </option>
                      <option value="artificial intelligence solutions">
                        Artificial Intelligence Solutions
                      </option>
                      <option value="others"> Others</option>
                    </select>
                    <span className="error_msg_text">
                      <p className="text-danger mb-0">
                        {errors.service?.message}
                      </p>
                    </span>
                  </div>
                  <div>
                    <textarea
                      placeholder="Type Content Here..."
                      rows={5}
                      {...register("content")}
                    ></textarea>
                    <p className="text-danger mb-0">
                      {errors.content?.message}
                    </p>
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="button login__submit login_new"
                  >
                    <span className="button__text">
                      {" "}
                      Submit {loading && <Loading />}
                    </span>
                    <i className="button__icon fas fa-chevron-right"></i>
                  </button>
                </form>
              </div>
            </Col>
            <Col >
              <div className="talk_us_right">
                <h2>Contact Us</h2>
                <p>
                  Feel free to reach out to Justtry Technologies for any
                  inquiries or support. Our team is here to assist you!
                </p>
              </div>
            </Col>
          </Row>
          <div className="talk_to_us_image d-lg-block d-none">
            <img src={talk_to_us} alt="new-img" />
          </div>
        </div>
      </TalkToUsPopup>
    </Fragment>
  );
};

export default TalkToUsNew;
